import { MessageSquare, Loader2 } from 'lucide-react';
import { useSessions } from '../hooks/useSessions';

export function SessionsPage() {
  const { data: sessions, isLoading } = useSessions();

  if (isLoading) {
    return <div className="flex items-center justify-center py-20"><Loader2 className="w-5 h-5 text-zinc-600 animate-spin" /></div>;
  }

  if (!sessions?.length) {
    return (
      <div className="text-center py-20 text-zinc-600">
        <MessageSquare className="w-8 h-8 mx-auto mb-2 opacity-50" />
        <p className="text-sm">No sessions yet</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {sessions.map(s => (
        <div key={s.id} className="bg-surface border border-border rounded-lg px-4 py-3 flex items-center gap-4">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-zinc-200">{s.agent}</span>
              <span className="text-[10px] font-mono text-zinc-600">{s.adapter}:{s.channel}</span>
            </div>
            <div className="text-[11px] text-zinc-500 mt-0.5">
              {s.messages} message{s.messages !== 1 ? 's' : ''} · {new Date(s.created).toLocaleString()}
            </div>
          </div>
          <code className="text-[10px] text-zinc-600 font-mono shrink-0">{s.id.slice(0, 8)}</code>
        </div>
      ))}
    </div>
  );
}
